/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-indent */
import { Input } from 'components/atoms';
import { useEffect, useRef, useState } from 'react';
import AddressService from 'services/AddressService';
import styles from './styles.module.css';

const TABS = ['จังหวัด', 'อำเภอ/เขต', 'ตำบล/แขวง'];

export default function AddressSelect(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [selected, setSelected] = useState({
    province: '',
    district: '',
    ward: '',
  });
  const [search, setSearch] = useState('');
  const [districts, setDistricts] = useState([]);
  const [wards, setWards] = useState([]);
  const [fullAddress, setFullAddress] = useState('');
  const containerRef = useRef(null);

  const { provinces = [], setValue, error, icon, placeholder } = props;

  const handleClickOutside = (e) => {
    if (containerRef.current && !containerRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const getDistricts = async () => {
    const prvCode = selected.province.value;
    if (!prvCode) return;
    const districtsRes = await AddressService.getDistrictsByProvince(prvCode);
    setDistricts(districtsRes);
  };

  const getWards = async () => {
    const distCode = selected.district.value;
    if (!distCode) return;
    const wardsRes = await AddressService.getWardsByDistrict(distCode);
    setWards(wardsRes);
  };

  useEffect(() => {
    getDistricts();
    getWards();
  }, [selected.province, selected.district, selected.ward]);

  // useEffect(() => {
  // 	if (!selected.province || !selected.district || !selected.ward) return;
  // 	setFullAddress(`${selected.ward.label || "--"}/${selected.district.label || "--"}/${selected.province.label || "--"}`);
  // }, [selected]);

  const handleSelect = (value) => {
    if (activeTab === 0) {
      const newSelected = { province: value, district: '', ward: '' };
      setSelected(newSelected);
      setValue('provinceCode', value.value);
      setActiveTab(1);
    } else if (activeTab === 1) {
      const newSelected = { ...selected, district: value, ward: '' };
      setSelected(newSelected);
      setValue('districtCode', value.value);
      setActiveTab(2);
    } else {
      const newSelected = { ...selected, ward: value };
      setSelected(newSelected);
      setValue('wardCode', value.value);
      setFullAddress(
        `${value.label || '--'}/${selected.district.label || '--'}/${
          selected.province.label || '--'
        }`,
      );
      setIsOpen(false);
    }

    setSearch('');
  };

  return (
    <div className="relative" ref={containerRef}>
      {/* Input Box */}
      <Input
        startAdornment={icon}
        placeholder={placeholder}
        type="text"
        readOnly
        className={styles.input}
        value={fullAddress}
        error={error}
        onClick={() => setIsOpen(!isOpen)}
      />

      {/* Dropdown */}
      {isOpen && (
        <div className="absolute z-10 top-full mt-1 bg-white border rounded-lg w-full shadow-lg">
          {/* Tabs */}
          <div className="flex border-b">
            {TABS.map((label, index) => (
              <button
                key={label}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setActiveTab(index);
                }}
                className={`flex-1 text-sm p-2 text-center ${
                  activeTab === index
                    ? 'text-[#005c29] border-b-2 border-[#005c29]'
                    : 'text-gray-500'
                }`}
              >
                {label}
              </button>
            ))}
          </div>

          {/* Search */}
          <div className="p-2 border-b">
            <input
              type="text"
              placeholder="ค้นหา"
              className="w-full border rounded px-2 py-1 text-sm"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          {/* Options */}
          {activeTab === 0 && (
            <ul className="max-h-60 overflow-y-auto p-2 space-y-1 text-sm">
              {provinces
                .filter((item) => item.label.includes(search))
                .map((item) => (
                  <li
                    key={item.value}
                    className="cursor-pointer px-2 py-1 hover:bg-gray-100 rounded"
                    onClick={() => handleSelect(item)}
                  >
                    {item.label}
                  </li>
                ))}
            </ul>
          )}

          {activeTab === 1 && (
            <ul className="max-h-60 overflow-y-auto p-2 space-y-1 text-sm">
              {districts
                .filter((item) => item.label.includes(search))
                .map((item) => (
                  <li
                    key={item.value}
                    className="cursor-pointer px-2 py-1 hover:bg-gray-100 rounded"
                    onClick={() => handleSelect(item)}
                  >
                    {item.label}
                  </li>
                ))}
            </ul>
          )}

          {activeTab === 2 && (
            <ul className="max-h-60 overflow-y-auto p-2 space-y-1 text-sm">
              {wards
                .filter((item) => item.label.includes(search))
                .map((item) => (
                  <li
                    key={item.value}
                    className="cursor-pointer px-2 py-1 hover:bg-gray-100 rounded"
                    onClick={() => handleSelect(item)}
                  >
                    {item.label}
                  </li>
                ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
